import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Breakpoints, BrowserEvents, Classes, Elements } from '../global/constants';
import { mediaQueryString } from '../global/helpers';

gsap.registerPlugin(ScrollTrigger);

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Variables ----------

		let mobileAnimations = [];
		let smAnimations = [];
		let desktopAnimations = [];
		let globalAnimations = [];

		// ---------- Animated Section ----------

		$('.animated-section:not(.transition-clone)').each(function() {

			globalAnimations.push(() => {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						once: true,
						start: 'top 80%',
						toggleClass: Classes.active,
					}
				});
			});
		});

		// ---------- Parallax Section ----------

		$('.simple-text-images-section, .horizontal-text-images-section, .vertical-text-images-section, .dates-section').each(function() {

			desktopAnimations.push(() => {

				const images = this.querySelectorAll(':scope .slideshow-column');
				const speed = 20;

				images.forEach(image => {

					if(image) {

						const timeline = gsap.timeline({
							scrollTrigger: {
								trigger: this,
								start: 'top bottom',
								end: 'bottom top',
								scrub: true,
							},
						});

						timeline.to(image, { yPercent: speed, ease: 'none' });
					}
				});
			});
		});

		// ---------- Parallax Section ----------

		$('.parallax-section:not(.fixed-parallax-section):not(.transition-clone)').each(function() {

			smAnimations.push(() => {

				const image = this.querySelector(':scope .section-image');
				const speed = 25;

				if(image) {

					const timeline = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true,
						},
					});

					timeline.fromTo(image, { yPercent: -speed }, { yPercent: speed, ease: 'none' });
				}
			});
		});

		// ---------- Hero Section ----------

		$('.hero-section').each(function() {

			smAnimations.push(() => {

				const content = this.querySelector(':scope .section-content .content');
				const speed = 100;

				if(content) {

					const timeline = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: 'top top',
							end: 'bottom top',
							scrub: true,
						},
					});

					timeline.to(content, { yPercent: speed, ease: 'none' });
				}
			});
		});

		// ---------- Sticky Header ----------

		$Elements.HeaderWrapper.each(function() {

			globalAnimations.push(() => {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						endTrigger: Elements.PageWrapper,
						start: 1,
						toggleClass: Classes.menuLight,
					}
				});
			});
		});

		// ---------- History dates ----------

		const historyDate = document.querySelector('.history-date');
		let historyDates = [];

		$('.data-history-date').each((i, e) => historyDates.push($(e).text()));

		if(historyDate && historyDates.length) {

			globalAnimations.push(() => {

				const num = { var: historyDates[0] };
				const datesSections = $('.dates-section');

				$(historyDate).text(num.var);

				const historyDateTimeline = gsap.timeline({
					scrollTrigger: {
						trigger: datesSections.first(),
						pin: false,
						start: 'top top',
						endTrigger: datesSections.last(),
						end: 'bottom bottom',
						scrub: true
					}
				});

				historyDateTimeline.to(num, {
					var: parseInt(historyDates[historyDates.length - 1], 10),
					duration: 5,
					ease: 'none',
					onUpdate: () => $(historyDate).text((num.var).toFixed()),
				});
			});
		}

		// ---------- Sidebar section scroll ----------

		$('.gites-intro-section').each(function() {

			const content = this.querySelector('.content-column:last-child:not(:first-child) .content');

			if(content) {

				smAnimations.push(() => {

					const timeline = gsap.timeline({
						scrollTrigger: {
							trigger: content,
							start: 'bottom bottom',
							endTrigger: '.footer-wrapper',
							end: 'top bottom',
							pin: true,
							pinSpacing: false,
						}
					});
				});
			}
		});

		// ---------- Handle Media Queries ----------

		ScrollTrigger.matchMedia({

			// Desktop Animations
			[mediaQueryString(Breakpoints.Mobile)]: () => desktopAnimations.map(animation => animation()),

			// Mobile Animations
			[mediaQueryString(Breakpoints.sm)]: () => smAnimations.map(animation => animation()),

			// Mobile Animations
			[mediaQueryString(Breakpoints.Mobile, false)]: () => mobileAnimations.map(animation => animation()),

			// Global Animations
			'all': () => globalAnimations.map(animation => animation()),

		});

	});

}(jQuery));
